import axiosInstance from "./AxiosApi";

//get details suers
export const getUSerDetalis = (pageNum) => {
  return axiosInstance.get(`User/GetAll/${pageNum}`);
};

//create new user
export const createUser = (userData) => {
  return axiosInstance.post(`User/CreateUser`, userData);
};

//edit user
export const updateUser = (formData) => {
  return axiosInstance.post(`User/UpdateUser`, formData);
};

//delete user
export const deleteUser = (userId) => {
  return axiosInstance.post(`User/RemoveUser/${userId}`);
};

//getuser by id
export const getUserById = (userId) => {
  return axiosInstance.get(`User/GetById/${userId}`);
};

//project api section

export const getAllProject = (pageNum) => {
  return axiosInstance.get(`Project/${pageNum}`);
};

export const getProjectDetails = (projectID) => {
  return axiosInstance.get(`Project/AllById/${projectID}`);
};

export const addProject = (formData) => {
  return axiosInstance.post(`Project/Add `, formData);
};

export const removeProject = (userId) => {
  return axiosInstance.post(`Project/Delete/${userId}`);
};

export const editProject = (ProjectData) => {
  return axiosInstance.post(`Project/Update`, ProjectData);
};

export const editSearchUser = (UserDataSearch) => {
  return axiosInstance.get(`User/SearchUser/${UserDataSearch}`);
};

export const removeProjectImg = (imgID) => {
  return axiosInstance.post(`Image/DeletePicture/${imgID}`);
};

// api employe Prof
export const getProjectDetailsProf = (employeId) => {
  return axiosInstance.get("");
};

export const editEmploye = (employeData) => {
  return axiosInstance.post(`myUser/updateInfo`, employeData);
};

//employe apis

export const FetchImages = () => {};

export const getUserProjectDetails = (idProject) => {
  return axiosInstance.get(`myUser/project/${idProject}`);
};

export const getProjectList = (idUser) => {
  return axiosInstance.get(`myUser/projects/${idUser}`);
};

export const passSend = (passData) => {
  return axiosInstance.post("myUser/resetPass", passData);
};

//login form
export const LoginFormDataFetch = (loginData) => {
  return axiosInstance.post(`Auth/Login`, loginData);
};
export const LoginDirectLoginFetch = (loginData) => {
  return axiosInstance.post(`Auth/DirectLogin`, loginData);
};
//get all details for employer
export const getDataFullUser = () => {
  return axiosInstance.get(`myUser`);
};

//? employer update fetch route
export const getDataProjectList = () => {
  return axiosInstance.get("myUser/projects");
};
export const getImageGallery = (id)=>{
  return axiosInstance.get(`myUser/project/gallery/${id}`);
}
export const getAllDataAfterSelectPr = (projectId) => {
  return axiosInstance.get(`myUser/project/${projectId}`);
};
export const getDataStatistics = (projectId)=>{

  return axiosInstance.get(`myUser/Statistics/${projectId}`)
}

export const LogOut = ()=>{

  return axiosInstance.post(`auth/Logout`)
}

export const getContractData = async (contractId) => {
  
  const response = await axiosInstance.get(`contract/${contractId}`,{responseType:'blob'
  });
   const fileURL = URL.createObjectURL(response?.data);
   return fileURL
};

export const getMeetData = (projectId) => {
  return axiosInstance.get(`meeting/project/${projectId}`);
};

export const successMeet = (formData) => {
  return axiosInstance.post("meeting/update/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getDataAttri = (attriId) => {
  return axiosInstance.get(`services/${attriId}`);
};

//? api list for main page
export const apiListMainPage = [
  { title: "allLastPr", URL: "https://api.pendartarharia.com/home/projects" },
  {
    title: "hospital",
    URL: "https://api.pendartarharia.com/home/projects/category/residential",
  },
  {
    title: "treatment",
    URL: "https://api.pendartarharia.com/home/projects/category/treatment",
  },
  {
    title: "administrative",
    URL: "https://api.pendartarharia.com/home/projects/category/administrative",
  },
  {
    title: "allProjectList",
    URL: "https://api.pendartarharia.com/home/projects/all",
  },
];
